import dynamic from 'next/dynamic'
import { BlockProps } from '../BlockProps'
import { ISearchCoverBlockData } from './ISearchCoverBlockData'

export const DynamicSearchCoverBlock = dynamic<
  BlockProps<ISearchCoverBlockData>
>(() => import('./SearchCoverBlock').then((md) => md.SearchCoverBlock))
